export default __webpack_public_path__ + "static/media/we1.6f262fcc.png";